<template>
  <div class="page-content">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h3>Billings</h3>
            <div class="row d-flex justify-content-between align-items-center pt-3">
              <div class="col-4 col-sm-4">
                <el-date-picker v-model="search.date_range" type="daterange" @change="doSearch()"
                  :picker-options="date_picker_options" range-separator="To" start-placeholder="Start date"
                  end-placeholder="End date">
                </el-date-picker> &nbsp;
              </div>
              <div class="col-3 col-sm-3">
                <el-select class="w-100" id="status" @change="doSearch()" clearable v-model="search.status">
                  <el-option key="waiting_payment" label="Waiting Payment" value="waiting_payment"></el-option>
                  <el-option key="manual" label="Manual Waiting Payment" value="manual"></el-option>
                  <el-option key="paid" label="Paid" value="paid"></el-option>
                  <el-option key="cancelled" label="Cancelled" value="cancelled"></el-option>
                  <!-- <el-option key="postpaid" label="Postpaid" value="postpaid"></el-option> -->
                  <el-option key="failed" label="Failed" value="failed"></el-option>
                </el-select>
              </div>
              <div class="col-3 col-sm-3">
                <el-select class="w-100" id="company_id" @change="doSearch()"
                  filterable clearable
                  :filter-method="handlerSearchCompany" v-model="search.company_id">
                  <el-option key="" label="All Company" value=""></el-option>
                  <el-option v-for="cp in company_list" :key="cp.id" :label="cp.name" :value="cp.id"></el-option>
                </el-select>
              </div>
              <div class="col-2 col-sm-2">
                <el-button :loading="loading.table" @click="downloadReport();" type="primary" class="btn-primary" icon="el-icon-download">Download</el-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover" v-loading="loading.table">
                <thead>
                  <tr>
                    <th>Company</th>
                    <th>Workspace</th>
                    <th>Created Date</th>
                    <th>Subs Start Date</th>
                    <th>Blocked Date</th>
                    <th>Name</th>
                    <th>Invoice Number</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Payment Method</th>
                    <th>Expired VA</th>
                    <th>Ref. Number</th>
                    <th>Paid At</th>
                    <th>Cancelled At</th>
                    <th>#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in rows" :key="i">
                    <td>{{ item.company.name }}</td>
                    <td>{{ item.workspace_name }}</td>
                    <td>{{ item.date_str }}</td>
                    <td>{{ item.periode_start_at_str }}</td>
                    <td>
                      <el-tag v-if="item.blocked_label" effect="dark" size="mini" :type="item.blocked_label">{{ item.blocked_date_str }}</el-tag>
                      <span v-else >{{ item.blocked_date_str }}</span>
                    </td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.invoice_number }}</td>
                    <td>{{ item.topup_amount_str }}</td>
                    <td>
                      <el-tag size="mini" :type="item.tag_type">{{ item.status_str }}</el-tag>
                    </td>
                    <td>{{ check_payment(item) }}</td>
                    <td>{{ item.expired_at_str || '-' }}</td>
                    <td>{{ item.reference_number || '-' }}</td>
                    <td>{{ item.paid_at_str || '-' }}</td>
                    <td>{{ item.cancelled_at_str || '-' }}</td>
                    <td>
                      <!-- <a :href="item.topup_receipt_url" class="text-normal" target="_blank" v-if="item.status == 'paid' || item.status == 'waiting_payment'">
                        <font-awesome icon="file-pdf"/>&nbsp;{{ item.status == 'waiting_payment' ? 'Proforma Invoice' : 'Invoice' }}
                      </a>
                      <span v-else>-</span> -->
                      <!-- <el-button type="warning" @click="handlerEditProforma(item)" v-if="item.status == 'waiting_payment' && item.workspace_info.is_manual == true && ['finance', 'admin'].includes(checkUser.role.name.toLowerCase())" size="mini">Edit Invoice</el-button> -->
                      <!-- <el-button type="warning" @click="handlerEditProforma(item)" v-else-if="item.status == 'waiting_payment' && item.workspace_info.is_manual !== true && ['finance', 'admin', 'bussiness'].includes(checkUser.role.name.toLowerCase())" size="mini">Edit Proforma</el-button> -->
                      <el-button @click="handlerBtnSetPayment(item, 'paid')" v-if="['finance', 'admin'].includes(checkUser.role.name.toLowerCase()) && item.status == 'waiting_payment' && item.workspace_info.is_manual == true" size="mini">Already Pay</el-button>
                      <el-button @click="handlerBtnSetPayment(item, 'paid')" v-else-if="['finance', 'admin'].includes(checkUser.role.name.toLowerCase()) && item.status == 'waiting_payment'" size="mini">Payment To MWS Account</el-button>
                      <el-button @click="handlerBtnPay(item)" v-if="['bussiness', 'admin'].includes(checkUser.role.name.toLowerCase()) && item.status == 'waiting_payment' && item.workspace_info.is_reseller == true && item.workspace_info.type == 'reseller'" size="mini">Send VA</el-button>
                      <el-button @click="handlerBtnPayWithBalance(item)" v-if="['finance', 'admin'].includes(checkUser.role.name.toLowerCase()) && item.status == 'waiting_payment' && item.payment_method !== 'postpaid' && item.workspace_info.is_manual !== true" size="mini" type="success" plain>{{ $t('billing.pay_with_balance.button') }}</el-button>
                      <el-button @click="handlerDownloadInvoice(item)" v-if="item.status == 'waiting_payment' || item.payment_method == 'postpaid'" size="mini">Download Proforma</el-button>
                      <el-button type="primary" @click="handlerDownloadInvoice(item)" v-if="item.status == 'paid' && item.payment_method !== 'postpaid'" size="mini">Download Invoice</el-button>
                      <el-button @click="handlerBtnSetPayment(item, 'void')" v-if="['finance', 'admin'].includes(checkUser.role.name.toLowerCase()) && item.status == 'waiting_payment'" size="mini" type="danger" plain>Cancel Billing</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <el-empty v-if="!rows.length" description="No histories"></el-empty>
            </div>
            <b-pagination v-if="total_row > search.per_page" v-model="currentPage" :total-rows="total_row" :per-page="search.per_page"/>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="lg" v-model="show_modal.pay_billing" title="Pay Billing" hide-footer @hide="onHidePayBiling">
      <el-steps :active="current_step" finish-status="success" simple="">
        <el-step title="Fill Data" icon="el-icon-warning-outline"></el-step>
        <el-step title="Payment Detail" icon="el-icon-postcard"></el-step>
      </el-steps>
      <template v-if="current_step == 0">
        <b-form>
          <el-descriptions class="mt-2" title="Billing Information" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-document"></i>
                Name
              </template>
              {{ selected_billing.name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-money"></i>
                Amount
              </template>
              IDR {{ selected_billing.amount.toLocaleString('id-ID') }}
            </el-descriptions-item>
          </el-descriptions>
          <br/>
          <b-form-group label="Payment Method">
            <el-select v-model="form1.payment_method_id" placeholder="Please choose payment method" class="w-100">
              <el-option v-for="item in sof" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </b-form-group>
          <div class="d-flex flex-row float-right mt-2">
            <el-button :loading="loading.pay_billing" @click="handlerBtnNext" :disabled="!form1.payment_method_id" class="mr-2 ml-2" size="small" type="primary">Create Va</el-button>
            <el-button @click="show_modal.pay_billing = false" size="small" class="mr-2">Cancel</el-button>
          </div>
        </b-form>
      </template>
      <template v-if="current_step == 1">
        <b-form>
          <el-descriptions class="mt-2" title="Payment Detail" :column="1" border>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-document"></i>
                Name
              </template>
              {{ selected_billing.name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-money"></i>
                Amount
              </template>
              IDR {{ selected_billing.amount.toLocaleString('id-ID') }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-s-custom"></i>
                Admin Fee
              </template>
              IDR {{ (selected_billing.admin_fee || 0).toLocaleString('id-ID') }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-money"></i>
                Total Payment
              </template>
              IDR {{ (selected_billing.total_transaction || 0).toLocaleString('id-ID') }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                Payment Method
              </template>
              {{ selected_billing.payment_metadata.va_list[0].name }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-wallet"></i>
                Virtual Account Number
              </template>
              {{ selected_billing.virtual_account_number }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-message"></i>
                Status
              </template>
              <el-tag size="mini" :type="selected_billing.tag_type">{{ selected_billing.status.replace('_', ' ').toUpperCase() }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-date"></i>
                Expired Date
              </template>
              {{ moment(selected_billing.expired_at).format('DD MMM YYYY, HH:mm') }}
            </el-descriptions-item>
          </el-descriptions>
          <div class="mt-3 mb-3"><strong>How to pay</strong></div>
          <el-collapse v-model="active_collapse_howtopay" accordion>
            <el-collapse-item v-for="(item, index) in selected_billing.payment_metadata.va_list[0].how_to_pay" :key="index" :title="item.channel" :name="index">
              <ol>
                <li v-for="(step, i) in item.step" :key="i">{{ step }}</li>
              </ol>
            </el-collapse-item>
          </el-collapse>
          <hr/>
          <b-form-group label="Payment Method">
            <el-select v-model="form1.payment_method_id" placeholder="Please choose payment method" class="w-100">
              <el-option v-for="item in sof" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </b-form-group>
        </b-form>
        <div class="d-flex flex-row float-right mt-2">
          <el-button :loading="loading.pay_billing" @click="handlerBtnNext" :disabled="!form1.payment_method_id" class="mr-2 ml-2" size="small" type="primary">Resend VA</el-button>
          <el-button @click="show_modal.pay_billing = false" size="small" class="mr-2">Close</el-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="sm" v-model="show_modal.create_invoice" :title="`Paid Billing ${payment_invoice.workspace_name}`" hide-footer>
      <b-form @submit.prevent="createInvoice" @reset="closeModal">
        <b-form-group label="Paid At:" label-for="paid-at">
          <el-date-picker id="paid-at" v-model="payment_invoice.paid_at" type="date" placeholder="Choose date" required />
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- <b-modal v-model="show_modal.edit_proforma" :title="`Edit Proforma ${platform_subscription.workspace_name}`" hide-footer @hide="closeModal">
      <b-form @submit.prevent="saveBilling" @reset="closeModal">
        <b-form-group label-class="font-weight-bold pt-0" label="Platform Subscription Pricing">
          <b-row>
            <b-form-group class="col-md-6" id="ws-period" label="Period : " label-for="ws-period">
              <b-form-select id="ws-period" @change="choosePackage" v-model="platform_subscription.subscription_period" :options="subs_period.filter((v) => v.value !== 'lifetime')" />
            </b-form-group>
            <b-form-group class="col-md-6" v-if="platform_subscription.subscription_period == 'month'" label="Biling Cycle in Month" label-for="platform-subscription-month">
              <b-form-select id="ws-subs-month" @input="getTotal" v-model="platform_subscription.subscription_lifetime" placeholder="Input biling cycle month" required>
                <b-form-select-option v-for="(index) in 11" :key="index" :value="index">{{ index }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group class="col-md-6" label="Biling Start Date" label-for="platform-subscription-date">
              <b-form-input id="ws-subs-date" v-model="platform_subscription.subscription_date" max="28" min="1" type="number" placeholder="Set billing date" :disabled="form_subs_disabled || is_subs_exists" required/>
            </b-form-group>
            <b-form-group class="col-md-6" v-if="platform_subscription.status == 'new'" label="Biling Start Month" label-for="platform-subscription-start-month">
              <b-form-select id="ws-subs-month" v-model="platform_subscription.subscription_month" placeholder="Set biling month" required>
                <b-form-select-option v-for="(index) in 12" :key="index" :value="index">{{ start_month[index-1] }}</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-6" label="Pricing">
              <b-form-input @input="getTotal" v-model="platform_subscription.subscription_price" placeholder="Input price" step=".01" v-money="currency_mask" required/>
              <span class="text-muted">Pricing in a {{ platform_subscription.subscription_period }}</span>
            </b-form-group>
            <b-form-group class="col-md-6" label="Total price">
              <b-form-input disabled placeholder="Total price" step=".01" :value="Number(platform_subscription.subscription_total).toLocaleString('id-ID')" required/>
              <span class="text-muted">Price after discount</span>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-6" label="Discount type" >
              <select @change="getTotal" class="form-select rounded-sm" v-model="platform_subscription.discount_type" >
                <option value="percentage">Percentage</option>
                <option value="price">Price</option>
              </select>
            </b-form-group>
            <b-form-group v-if="platform_subscription.discount_type === 'price'" class="col-md-6" label="Discount price (Rp)">
              <b-form-input min="0" @input="getTotal" v-model="platform_subscription.discount_price" v-money="currency_mask" placeholder="Input discount" step=".01" />
            </b-form-group>
            <b-form-group v-if="platform_subscription.discount_type === 'percentage'" class="col-md-6" label="Discount percentage (%)">
              <b-form-input min="0" @input="getTotal" v-model="platform_subscription.discount_percentage" v-money="currency_mask" placeholder="Input discount" />
            </b-form-group>
          </b-row>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <b-button type="submit" variant="primary" class="ml-2">{{ $t('general.submit') }}</b-button>
          <b-button type="reset" variant="secondary">{{ $t('general.cancel') }}</b-button>
        </div>
      </b-form>
    </b-modal> -->
  </div>
</template>
<script>
import moment from 'moment';
import { isEqual } from 'lodash';
import topupApi from '../../api/topup';
import billingsApi from '../../api/billings';
import logAPI from '../../api/log';
import popupErrorMessages from '../../library/popup-error-messages';

export default {
  name: 'Billings',
  metaInfo: {
    title: 'Billings',
  },
  data() {
    return {
      moment,
      loading: {
        table: false,
        pay_billing: false,
      },
      active_collapse_howtopay: '',
      show_modal: {
        pay_billing: false,
        create_invoice: false,
        edit_proforma: false,
      },
      sof: [],
      current_step: 0,
      search: {
        date_range: [
          this.$route.query?.start_date || moment().subtract(1, 'month'),
          this.$route.query?.end_date || moment(),
        ],
        company_id: this.$route.query?.company_id || '',
        page: this.$route.query?.page || 1,
        per_page: this.$route.query?.per_page || 10,
        status: this.$route.query?.status || '',
        // search_by: this.$route.query?.search_by || 'invoice_number',
      },
      rows: [],
      total_row: 0,
      search_by_options: [
        {
          value: 'invoice_number',
          text: 'Invoice Number',
        },
        {
          value: 'reference_number',
          text: 'Ref. Number',
        },
      ],
      date_picker_options: {
        // disabledDate: (time) => {
        //   const today = moment();
        //   const diff = today.diff(moment(time), 'd');
        //   if (diff > 90 || diff < 0) {
        //     return true;
        //   }
        //   if (diff === 0) {
        //     if (today.isSame(moment(time), 'd') === false) {
        //       return true;
        //     }
        //   }
        //   return false;
        // },
        shortcuts: [
          {
            text: 'This week',
            onClick(picker) {
              const start = moment().startOf('week').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'This month',
            onClick(picker) {
              const start = moment().startOf('month').format();
              const end = moment().format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last week',
            onClick(picker) {
              const start = moment().subtract(1, 'week').startOf('week').format();
              const end = moment().subtract(1, 'week').endOf('week').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last month',
            onClick(picker) {
              const start = moment().subtract(1, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last 3 months',
            onClick(picker) {
              const start = moment().subtract(3, 'month').startOf('month').format();
              const end = moment().subtract(1, 'month').endOf('month').format();
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      selected_billing: {
        amount: 0,
        admin_fee: 0,
        payment_metadata: {
          va_list: [],
        },
      },
      form1: {
        payment_method_id: '',
      },
      company_list: [],
      workspace_active_id: '',
      payment_invoice: {
        id: '',
        workspace_name: '',
        workspace_id: '',
        company_id: '',
        paid_at: '',
      },
      platform_subscription: {
        workspace_id: '',
        workspace_name: '',
        subscription_year: '2026',
        subscription_period: 'month',
        subscription_lifetime: 1, // month. used for billing cycle
        subscription_date: '',
        subscription_month: '',
        subscription_price: '0',
        subscription_total: '0',
        discount_type: '',
        discount_price: '0',
        discount_percentage: '0',
        status: '',
        is_reseller: false,
        reseller_email: null,
      },
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.search.page;
      },
      set(val) {
        this.search.page = val;
        this.getList();
      },
    },
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    checkUser() {
      return this.$store.state.backOffice.userProfile;
    },
  },
  mounted() {
    this.getList();
    topupApi.paymentMethodList().then(({ data }) => {
      this.sof = data.sof;
    });
  },
  methods: {
    check_payment(item) {
      let method = (item.payment_metadata?.va_list[0].name || '-');
      if (item.workspace_info?.is_manual === true && item.status !== 'paid') {
        method = 'MANUAL';
      } else if (['postpaid', 'system', 'finance', 'balance'].includes(item.payment_method)) {
        method = item.payment_method.toUpperCase();
      }
      return method;
    },
    doSearch() {
      this.search.page = 1;
      this.search.per_page = 10;
      this.getList();
    },
    handlerSearchCompany(value) {
      clearTimeout(this.timeout_search_user);
      this.timeout_search_user = setTimeout(() => {
        this.getCompanies('company_name', value);
      }, 1000);
    },
    async getCompanies(search_by = '', search = '') {
      await logAPI.getCompanies(1, search_by, search)
        .then(async (res) => {
          this.company_list = res.data.data.rows;
        });
    },
    /* eslint-disable radix */
    handlerNextPrev(value) {
      if (value === 'next') {
        this.search.page = parseInt(this.search.page) + 1;
        this.search.previous_page = null;
        if (!this.search.next_page) {
          return;
        }
      } else {
        this.search.page = parseInt(this.search.page) - 1;
        this.search.next_page = null;
        if (!this.search.previous_page) {
          return;
        }
      }
      this.getList();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async getList(action = '') {
      const options = {
        page: this.search.page.toString(),
        per_page: this.search.per_page.toString(),
        start_date: moment(this.search.date_range[0]).format('YYYY-MM-DD'),
        end_date: moment(this.search.date_range[1]).format('YYYY-MM-DD'),
        status: this.search.status,
        company_id: this.search.company_id,
      };
      if (!isEqual(options, this.$route.query)) {
        this.$router.replace({ query: options });
      }
      this.loading.table = true;
      if (action === 'download') options.action = 'download';
      await billingsApi.platformBillingHistories({
        query: options,
      }).then(({ data }) => {
        if (data.secure_url) {
          window.open(data.secure_url);
          return;
        }
        this.total_row = data.count;
        this.rows = [];
        if (data.rows) {
          this.rows = data.rows.map((v) => {
            v.date_str = moment(v.created_at).format('DD MMMM YYYY, HH:mm');
            const total_amount = parseFloat(v.amount) + parseFloat(v.tax_amount);
            v.topup_amount_str = `Rp. ${total_amount.toLocaleString('id')}`;
            v.periode_start_at_str = v.periode_start_at ? moment(v.periode_start_at).format('DD MMMM YYYY') : '-';
            v.blocked_date_str = '-';
            if (v.status === 'waiting_payment') {
              v.blocked_label = 'info';
              if (moment(v.created_at).format() > moment(v.periode_start_at).format()) {
                v.blocked_date_str = moment(v.created_at).add('28', 'days').format('DD MMM YYYY');
                if (moment().format() >= moment(v.created_at).add('25', 'days').format()) {
                  v.blocked_label = 'danger';
                }
              } else {
                v.blocked_date_str = moment(v.periode_start_at).add('15', 'days').format('DD MMM YYYY');
                if (moment().format() >= moment(v.periode_start_at).add('12', 'days').format()) {
                  v.blocked_label = 'danger';
                }
              }
            }
            v.paid_at_str = v.paid_at ? moment(v.paid_at).format('DD MMMM YYYY, HH:mm') : '-';
            v.cancelled_at_str = v.cancelled_at ? moment(v.cancelled_at).format('DD MMMM YYYY, HH:mm') : '-';
            v.expired_at_str = v.expired_at ? moment(v.expired_at).format('DD MMMM YYYY, HH:mm') : '-';
            v.status_str = v.status.replace('_', ' ').toUpperCase();
            v.tag_type = 'warning';
            // v.topup_receipt_url = topupApi.downloadInvoices({
            //   workspace_id: this.$route.params.workspace_id,
            //   id: v.id,
            // });
            if (v.status === 'paid') {
              v.tag_type = 'success';
            } else if (['expired', 'failed'].includes(v.status)) {
              v.tag_type = 'danger';
            } else if (v.status === 'cancelled') {
              v.tag_type = 'info';
            }
            // if (v.payment_method === 'postpaid' || v.payment_vendor === 'postpaid') {
            //   v.status_str = 'POSTPAID';
            //   v.tag_type = 'warning';
            // }
            return v;
          });
        }
      });
      this.loading.table = false;
    },
    handlerSearchBtn() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.search.next_page = null;
      this.search.previous_page = null;
      this.search.page = 1;
      this.getList();
    },
    async downloadReport() {
      this.getList('download');
    },
    handlerBtnPay(item) {
      this.show_modal.pay_billing = true;
      this.selected_billing = item;
      this.workspace_active_id = item.workspace_id;
      this.selected_billing.amount = parseFloat(item.total_transaction);
      if (item.expired_at && moment(item.expired_at).format() <= moment().format()) {
        this.selected_billing.amount = parseFloat(item.total_transaction) - parseFloat(item.admin_fee);
      }
      if (item.virtual_account_number && moment(item.expired_at).format() > moment().format()) {
        this.current_step += 1;
      }
      this.form1.payment_method_id = parseInt(item.payment_method);
    },
    handlerBtnSetPayment(item, status) {
      this.payment_invoice = {
        id: item.id,
        workspace_name: item.workspace_name,
        workspace_id: item.workspace_id,
        company_id: item.company_id,
        status,
      };
      if (status === 'paid') {
        this.payment_invoice.paid_at = moment().format('YYYY-MM-DD');
        this.show_modal.create_invoice = true;
      } else if (status === 'void') {
        this.createInvoice();
      }
    },
    createInvoice() {
      this.$confirm(this.$t('billing.payment.confirm'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const response = await billingsApi.updatePayment({
              workspace_id: this.payment_invoice.workspace_id,
              company_id: this.payment_invoice.company_id,
              invoice_id: this.payment_invoice.id,
              paid_at: this.payment_invoice.status === 'paid' ? this.payment_invoice.paid_at : null,
              status_billing: this.payment_invoice.status,
            });
            await popupErrorMessages(response);
            this.$message({
              message: this.$t('billing.payment.success'),
              type: 'success',
            });
            this.search.page = 1;
            this.search.per_page = 10;
            this.closeModal();
            this.getList();
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    handlerBtnPayWithBalance(item) {
      this.$confirm(this.$t('billing.pay_with_balance.confirm'), this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            try {
              const response = await billingsApi.payWithBalance({
                workspace_id: item.workspace_id,
                company_id: item.company_id,
                invoice_id: item.id,
              });
              // Rejects (and shows the message) when the API returns an error,
              // e.g. insufficient balance — keep the dialog open in that case.
              await popupErrorMessages(response);
              this.$message({
                message: this.$t('billing.pay_with_balance.success'),
                type: 'success',
              });
              this.getList();
            } catch (e) {
              instance.confirmButtonLoading = false;
              return;
            }
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    async handlerBtnNext() {
      this.loading.pay_billing = true;
      const res = await billingsApi.platformBillingGenerateVa({
        workspace_id: this.workspace_active_id,
        invoice_id: this.selected_billing.id,
        payment_method_id: this.form1.payment_method_id,
      });
      this.loading.pay_billing = false;
      await popupErrorMessages(res);
      this.$message({
        message: this.$t('billing.payment.success'),
        type: 'success',
      });
      if (this.current_step < 1) {
        this.current_step += 1;
      }
      this.selected_billing = res.data;
      this.selected_billing.tag_type = 'warning';
      this.selected_billing.amount = parseFloat(res.data.total_transaction);
      this.getList();
      this.show_modal.pay_billing = false;
    },
    onHidePayBiling() {
      this.current_step = 0;
      this.workspace_active_id = '';
      this.selected_billing = {
        amount: 0,
        admin_fee: 0,
        payment_metadata: {
          va_list: [],
        },
      };
      this.form1 = {
        payment_method_id: '',
      };
    },
    async handlerDownloadInvoice(item) {
      const { data } = await billingsApi.downloadInvoicePlatform({
        id: item.id,
        workspace_id: item.workspace_id,
      });
      window.open(data.url);
    },
    closeModal() {
      this.show_modal.create_invoice = false;
      this.payment_invoice = {
        id: '',
        workspace_name: '',
        workspace_id: '',
        company_id: '',
        paid_at: '',
      };
    },
    handlerEditProforma(item) {
      this.platform_subscription = {
        id: item.id,
        workspace_id: item.workspace_id,
        workspace_name: item.workspace_name,
        company_id: item.company_id,
        release_at: item.created_at,
        subscription_period: 'month',
        subscription_lifetime: 1, // month. used for billing cycle
        subscription_date: '',
        subscription_month: '',
        subscription_price: '0',
        subscription_total: '0',
        discount_type: '',
        discount_price: '0',
        discount_percentage: '0',
      };
      this.show_modal.edit_proforma = false;
    },
    saveBilling() {
    },
  },
};
</script>
